import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core'
import { DialogService } from '@app/core/_services/dialog.service'
import { take } from 'rxjs/operators'

@Component({
    selector: 'app-profile-info-status',
    templateUrl: './profile-info-status.component.html',
    styleUrls: ['./profile-info-status.component.scss'],
    standalone: false,
})
export class ProfileInfoStatusComponent implements OnInit {
    @Input() isSuspended: boolean
    @Input() isVerified: boolean
    @Input() planAccess: boolean
    @Input() canCancel: boolean
    @Input() isCanceled: boolean
    @Input() currentEmailAddress: string
    @Output() onSuspend: EventEmitter<any> = new EventEmitter<any>()
    @Output() onRestore: EventEmitter<any> = new EventEmitter<any>()
    @Output() onVerifyUser: EventEmitter<any> = new EventEmitter<any>()
    @Output() onCancelSub: EventEmitter<any> = new EventEmitter<any>()
    @Output() onUpdateEmailAddress: EventEmitter<string> = new EventEmitter<string>()

    public newEmailAddress: string = ''

    constructor(private dialogService: DialogService) {}

    ngOnInit() {}

    confirmUpdateEmailAddress() {
        this.dialogService
            .openConfirmUpdateEmailAddress(this.currentEmailAddress, this.newEmailAddress)
            .afterClosed()
            .pipe(take(1))
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.onUpdateEmailAddress.emit(this.newEmailAddress)
                }
            })
    }
}
